import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const LibraryRules = () => {
    useEffect(() => {
        document.title = 'Library Rules -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>Library Rules</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Library Rules </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                     <ul className="list"> 
                    <li>One library card is issued per student. </li> <li>A new book will not be issued till the card held by the student is returned. </li> <li>Books must be returned on the last date stamped on the label. </li> <li>Students are responsible for the books issued in their name. Books lost or damaged have to be paid for. </li> <li>Silence must be maintained in the library. </li> <li>The library cards are non-transferable. </li> <li>Personal books cannot be brought to the library </li>
                
                     </ul> 
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default LibraryRules